module.exports = "../../static/img/about_say.705fc52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_us_home/about_say.png
// module id = iREe
// module chunks = 1